import React, { useEffect, useState } from "react";
import { useProject } from "../../../../context/ProjectContext";
import SLAIndicatorsBar from "./SLAIndicators";
import AssignationIndicatorsBar from "./AssignationIndicators";
import './index.css'


interface SecondaryMenuBarProps {
  setTicketsList: (p: any) => void
  setLoadingTickets: (p: any) => void
  resetPrimaryFilter: () => void
  resetSecondaryFilter: boolean
}

const SecondaryMenuBar: React.FC<SecondaryMenuBarProps> = ({
  setTicketsList,
  resetPrimaryFilter,
  resetSecondaryFilter,
  setLoadingTickets }) => {

  const { isProjectUndefined } = useProject()
  const [filteredSLACode, setFilteredSLACode] = useState<string>('')
  const [filteredAssignationCode, setFilteredAssignationCode] = useState<string>('')
  const [resetSLAFilters, setResetSLAFilters] = useState<boolean>(false)
  const [resetAssignationFilters, setResetAssignationFilters] = useState<boolean>(false)

  useEffect(() => {
    setResetSLAFilters(!resetSLAFilters)
    setResetAssignationFilters(!resetAssignationFilters)
  }, [resetSecondaryFilter])

  useEffect(() => {
    if (filteredSLACode) {
      setFilteredAssignationCode('')
    }
  }, [filteredSLACode])

  useEffect(() => {
    if (filteredAssignationCode) {
      setFilteredSLACode('')
    }
  }, [filteredAssignationCode])

  return (
    <React.Fragment>
      <div className="tickets-listing-secbar-box" >
        {(!isProjectUndefined()) && (
          <AssignationIndicatorsBar
            setTicketsList={setTicketsList}
            resetPrimaryFilter={resetPrimaryFilter}
            setLoadingTickets={setLoadingTickets}
            filteredAssignationCode={filteredAssignationCode}
            setFilteredAssignationCode={setFilteredAssignationCode}
            resetAssignationFilters={resetAssignationFilters}
          />
        )}

        {(!isProjectUndefined()) && (
          <SLAIndicatorsBar
            setTicketsList={setTicketsList}
            resetPrimaryFilter={resetPrimaryFilter}
            setLoadingTickets={setLoadingTickets}
            filteredSLACode={filteredSLACode}
            setFilteredSLACode={setFilteredSLACode}
            resetSLAFilters={resetSLAFilters}
          />
        )}

      </div>

    </React.Fragment>
  );
}

export default SecondaryMenuBar
